import React, { Component } from "react";

import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha
} from "react-simple-captcha";

class Captcha extends Component {
  componentDidMount() {
    loadCaptchaEnginge(8,"rgba(142,151,161,.13)", "#9ec7d9");
  }

  doSubmit = () => {
    let user_captcha = document.getElementById("user_captcha_input").value;

    if (validateCaptcha(user_captcha) == true) {
        this.props.handleClaimButton();        
      //loadCaptchaEnginge(6);
      document.getElementById("user_captcha_input").value = "";
    } else {
        this.props.setTransactionData({error: "Captcha Does Not Match"})
      document.getElementById("user_captcha_input").value = "";
    }
  };

  render() {
    return (
      <div>
        <div className="container">
          <div className="form-group">
            <div className="col mt-3">
              <LoadCanvasTemplate />
            </div>

            <div className="col mt-3">
              <div>
                <input
                  placeholder="Enter Captcha"
                  id="user_captcha_input"
                  name="user_captcha_input"
                  type="text"
                  style={{borderRadius: "0.375rem"}}
                ></input>
              </div>
            </div>

            <div className="col mt-3">
              <div>
                <button
                  className="btn btn-primary"
                  onClick={() => this.doSubmit()}
                >
                  CLAIM REVO COINS!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Captcha;
